import { render, staticRenderFns } from "./FundsRegister.vue?vue&type=template&id=59bbc0e4"
import script from "./FundsRegister.vue?vue&type=script&lang=js"
export * from "./FundsRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports